import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchMyProfile = createAsyncThunk('getMyProfile/fetchMyProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosPrivate.get(api.myProfile);
      return response.data.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  })

const getMyProfileSlice = createSlice({
  name: 'User',
  initialState: {
    Myprofile: {},
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(fetchMyProfile.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(fetchMyProfile.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.Myprofile = action.payload;
        })
      .addCase(fetchMyProfile.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default getMyProfileSlice.reducer;